import React from 'react';
import { ICacheContext } from 'framework/context/ICacheContext';
import { ISuppliersFilterData } from 'gen/ApiClient';

export const SuppliersFilterDataContext = React.createContext<ICacheContext<ISuppliersFilterData>>(undefined as any);
